import { NextPage } from 'next';
import Head from 'next/head';
import BusinessSignUpForm from '../react-components/business/sign-up-form';
import Layout from '../react-components/layout';
import fancyList from '../styles/fancy-list.module.css';

const Business: NextPage = () => (
  <Layout>
    <Head>
      <title>FitSociety for Businesses</title>
      <meta
        name='description'
        content='Connect with customers near your business by establishing a presence on FITSOCIETY.COM. Just create an account to get started.'
      />
    </Head>
    <div>
      <h1 className='select-none'>Connect with Members Near Your Business</h1>
      <div className='max-w-5xl'>
        <ol className={`${fancyList.fancyList} font-medium`}>
          <li>
            <span>Create an account</span>
          </li>
          <li>
            <span>List products and services you offer</span>
          </li>
          <li>
            <span>Watch your business grow as nearby members find you</span>
          </li>
        </ol>
      </div>
    </div>
    <BusinessSignUpForm />
  </Layout>
);

export default Business;
